export function loader(show = true) {
    if (typeof window.loader === 'function') {
        window.loader(show)
    }
}

export function altFind(arr, callback) {
    for (var i = 0; i < arr.length; i++) {
        var match = callback(arr[i]);
        if (match) {
            return arr[i];
        }
    }
}

export function initLoader() {
    window.loader = (show = true) => {
        if (show) {
            jQuery('#spinner').css('visibility', 'visible');
            jQuery('.filterAjaxLoader').addClass('wdm-show-loader');
            jQuery('.ajaxBackground').addClass('wdm-show-loader');
            jQuery('.container, .full-width').addClass('ajax_in_progress');
        } else {
            jQuery('#spinner').css('visibility', 'hidden');
            jQuery('.filterAjaxLoader').removeClass('wdm-show-loader');
            jQuery('.ajaxBackground').removeClass('wdm-show-loader');
            jQuery('.container, .full-width').removeClass('ajax_in_progress');
        }
    }

    let body = document.getElementsByTagName('body')[0];
    let ajx = document.getElementsByClassName('filterAjaxLoader');
    let bg = document.getElementsByClassName('ajaxBackground');
    if (!ajx.length) {
        let loaderCnt = document.createElement('div');
        loaderCnt.className = 'filterAjaxLoader';
        body.prepend(loaderCnt)
    }
    if (!bg.length) {
        let bgCnt = document.createElement('div');
        bgCnt.className = 'ajaxBackground';
        body.prepend(bgCnt)
    }
}

/**
 *
 * @param {object} target
 * @param {object} assign
 */
export function assign(target, assign) {
    if (target && assign) {
        (Object.keys(assign)).forEach(key => {
            target[key] = assign[key];
        })
    }

    return target;
}

export function addToCart(e) {
    e.preventDefault();
    let cartBtn = jQuery(this);
    let id = jQuery(this).data('id');

    let data = {
        action: 'woocommerce_ajax_add_to_cart',
        product_id: id,
        product_sku: '',
        quantity: 1,
    };

    jQuery.ajax({
        type: 'post',
        url: wc_add_to_cart_params.ajax_url,
        data: data,
        beforeSend: function (response) {
            loader();
        },
        complete: function (response) {
            loader(false);
        },
        success: function (response) {
            console.log(response);
            if (response.error && response.product_url) {
                window.open(response.product_url, "_blank")
            } else {
                jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, cartBtn]);
                cartBtn.hide();
            }
        },
    });
}

export function formatPrice(price) {
    if (price) {
        price = parseFloat(price)
        price = price.toFixed(2).replace('.', ',');
    }
    return price;
}

export function isMsi() {
    let ua = window.navigator.userAgent;

    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

    // Edge 12 (Spartan)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

    // Edge 13
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    let msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    let trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        let rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    let edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
}

function createLevelObject(level) {
    let ul = null;
    if (level) {
        ul = document.createElement('ul');
        ul.classList.add('item-levels');
        let title = '';
        switch (level) {
            case 1:
                title = 'Einsteiger:innen'
                break;
            case 2:
                title = 'Fortgeschrittene'
                break;
            case 3:
                title = 'Erfahrene'
                break;
        }
        ul.title = title;
        for (let i = 1; i <= 3; i++) {
            let li = document.createElement('li');
            if (i <= level) {
                li.classList.add('fill');
            }
            ul.appendChild(li);
        }
    }

    return ul;
}

export function createListItem(item, liClass = 'col-lg-3') {
    let catName = item?.type_name ?? ''
    let msi = isMsi();

    let li = document.createElement('div');
    li.classList.add('result-container', 'col-md-6', liClass, 'flex-stretch');

    if (msi) {
        li.className += " col-md-6 flex-stretch " + liClass
    }

    let container = document.createElement('a');
    container.href = item.url;
    container.title = item.title;
    container.classList.add('result-holder');

    let image = document.createElement('div');
    image.classList.add('image');

    let img = document.createElement('img');
    img.src = item.image;
    image.appendChild(img);

    let info = document.createElement('div');
    info.classList.add('info');

    let cat = document.createElement('p');
    cat.classList.add('category');
    let catMeta = catName;
    if (item?.icon_url) {
        catMeta += ' <img src="' + item.icon_url + '" alt="' + catName + ' Ikone" class="cat-ico">';
    }
    cat.innerHTML = catMeta;

    let title = document.createElement('div');
    title.classList.add('title');
    title.innerHTML = '<h4>' + item.title + '</h4>';

    info.appendChild(cat);
    info.appendChild(title);

    if (item.cancelled) {
        let cancel = document.createElement('p');
        cancel.innerHTML = '<b>Abgesagt</b>';
        info.appendChild(cancel);
    }

    if (item.date) {
        let date = document.createElement('p');
        let dateInfo = '';

        if (item.following_dates?.length) {
            dateInfo = listFollowingAppointments(item.following_dates);
        }

        console.log(dateInfo);
        date.innerHTML = '<p>' + item.date + dateInfo + '</p>';
        info.appendChild(date);
    }

    if (item.duration) {
        let duration = document.createElement('p');
        duration.classList.add('duration');
        duration.innerHTML = '<p>Dauer: ' + item.duration + '</p>';
        info.appendChild(duration);
    }

    if (item.access) {
        let access = document.createElement('p');
        access.innerHTML = '<p>Zugriff: ' + item.access + '</p>';
        info.appendChild(access);
    }

    if (item.location) {
        let location = document.createElement('p');
        location.innerHTML = '<p>Ort: ' + item.location + '</p>';
        info.appendChild(location);
    }

    if (item.progress) {
        let progress = document.createElement('p');
        progress.innerHTML = '<p>Fortschritt: ' + item.progress + '</p>';
        info.appendChild(progress);
    }

    if (item.excerpt) {
        let excerpt = document.createElement('p');
        excerpt.classList.add('teaser');
        excerpt.innerHTML = item.excerpt;
        info.appendChild(excerpt);
    }

    container.appendChild(image);
    container.appendChild(info);

    let buyInfo = document.createElement('div');
    buyInfo.classList.add('buy-info');

    if (item.price) {
        let price = document.createElement('p');
        price.classList.add('price');
        price.innerText = formatPrice(item.price) + ' €';
        buyInfo.appendChild(price);
    }

    if (item.post_type === 'product' || item.product_id) {
        let product_id = item.product_id ? item.product_id : item.id;
        let product_url = item.product_url ? item.product_url : item.url;
        let actions = document.createElement('div');
        actions.classList.add('actions');
        let cartBtn = document.createElement('div');
        cartBtn.setAttribute('data-id', product_id);
        cartBtn.title = 'Zum Einkaufswagen hinzufügen';
        cartBtn.classList.add('action-btn');
        cartBtn.href = product_url;
        cartBtn.innerHTML = '<img src="' + item.assets_url + 'icons/cart_y.svg" alt="' + catName + ' Ikone" class="cat-ico">';
        cartBtn.addEventListener('click', addToCart);
        actions.appendChild(cartBtn);
        let detailsBtn = document.createElement('a');
        detailsBtn.title = 'Produktdetails anzeigen';
        detailsBtn.classList.add('action-btn')
        detailsBtn.href = product_url;
        detailsBtn.innerHTML = '<img src="' + item.assets_url + 'icons/details.svg" alt="' + catName + ' Ikone" class="cat-ico">';

        actions.appendChild(detailsBtn);
        buyInfo.appendChild(actions);
    }

    container.appendChild(buyInfo);

    li.appendChild(container)
    return li;
}

export function createEl(tag, classes, id, text, html = '') {
    let el = document.createElement(tag);

    if (classes) {
        classes = classes.split(' ');
        el.classList.add(...classes);
    }

    if (id) {
        el.id = id;
    }

    if (text) {
        el.innerText = text;
    }

    if (html) {
        el.innerHTML = html;
    }

    return el;
}

function listFollowingAppointments(dates) {
    let info = "Weitere Termine: &#013;"
    dates.forEach(date => {
        let d = date?.formatted.replace(/(<([^>]+)>)/gi, " ")
        info += d + " &#013;";
    })
    return '<span style="font-size: 18px; line-height: 10px; margin-left:5px" title="' + info + '">&#128712;</span>';
}

export function getIcon(name) {
    let ico = '';
    switch (name) {
        case 'edit':
            ico = '<i class="fa fa-pencil" aria-hidden="true"></i>';
            break;
    }
    return ico;
}

export function setEqualHeight(selector) {
    if (selector.length > 0) {
        var arr = [];
        var selector_height;
        selector.css("min-height", "initial");
        selector.each(function (index, elem) {
            selector_height = elem.offsetHeight;
            arr.push(selector_height);
        });
        selector_height = Math.max.apply(null, arr);
        selector.css("min-height", selector_height);
    }
}

export function commonRadioCheckBtn() {
    if (jQuery('.page-create-quiz').length == 0 && jQuery('.page-create-course').length == 0 && jQuery('.page-create-lesson').length == 0 && jQuery('.page-create-topic').length == 0 && jQuery('.page-create-question').length == 0 && jQuery('.buddypress.bp-nouveau').length == 0) {
        jQuery('input[type="radio"]').each(function (i, el) {
            var l = jQuery(el).parent('label');
            var radio_id = jQuery(el).attr('id');
            var radio_name = jQuery(el).attr('name');
            var radio_value = jQuery(el).val().toString();
            if (typeof radio_id == 'undefined') {
                radio_id = radio_name + '-' + radio_value;
                jQuery(el).attr('id', radio_id);
            }
            if (l.length > 0) {
                var label_for = l.attr('for');
                if (typeof label_for == 'undefined') {
                    l.attr('for', radio_id);
                }
                var rm = jQuery(el).detach();
                l.before(rm);
                l.addClass('radio-label');
            }
        })

        jQuery('input[type="checkbox"]').each(function (i, el) {
            if (jQuery(el).parent('.wdm-checkbox').length == 0) {
                jQuery(el).addClass('wdm-input-checkbox');
                jQuery(el).wrap("<div class='wdm-checkbox'></div>");
                jQuery(el).after("<i class='fa fa-check' aria-hidden='true'></i>");
            }
        })
        jQuery(window).load(function () {
            if (jQuery('.listcheckbox-wrap').length > 0) {
                jQuery('input[type="checkbox"]').each(function (i, el) {
                    if (jQuery(el).parent('.wdm-checkbox').length == 0) {
                        jQuery(el).addClass('wdm-input-checkbox');
                        jQuery(el).wrap("<div class='wdm-checkbox'></div>");
                        jQuery(el).after("<i class='fa fa-check' aria-hidden='true'></i>");
                    }
                })
            }

        })

    }
}

export function scrollToTop(selector, target) {
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop()) {
            jQuery(selector).fadeIn().css({ 'display': 'flex' });
        } else {
            jQuery(selector).fadeOut();
        }
    });

    document.querySelector(selector)?.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
}
